import { SET_USER } from "../constants";

export default (user) => ({
  type: SET_USER,
  user,
});
